export default 'icon--linkedin';